import React from "react";
import { footerLinks, offerConfig } from "../../data/megapack";
import { E } from "../Emoji";
export function Footer() {
  return <footer className="bg-night pb-28" data-id="element-152" data-mp="20716iyg4dnva">
      <div className="mx-auto max-w-2xl border-t border-line/40 px-5 pt-10 text-center text-sm" data-id="element-153" data-mp="2f4tjpjy7206b">
        <p className="font-black uppercase text-bright" data-id="element-154" data-mp="2a5qqqxvhnkep"><E data-id="element-155" data-mp="2a71vp10o6y7e">🧺 Senvoria Digital™</E></p>
        <p className="mt-2 text-white/70" data-id="element-156" data-mp="2a3w5tjk7vsam">Megapack Lavarropas — fallas y soluciones para tu hogar.</p>
        <p className="mt-3 font-bold italic text-white/70" data-id="element-157" data-mp="1mdtdr3gaymc0">
          Entender qué le pasa a tu lavarropas no debería ser un problema más.
        </p>
        <p className="mt-4 text-white/80" data-id="element-158" data-mp="1w70rpcp3zanp">
          <E data-id="element-159" data-mp="1w7sga3kag84h">{`📧 ${offerConfig.supportEmail} • 📲 ${offerConfig.social} • 🌐 ${offerConfig.domain}`}</E>
        </p>
        <nav aria-label="Enlaces legales" className="mt-3" data-id="element-160" data-mp="13peq8q571qfy">
          <ul className="flex justify-center gap-4" data-id="element-161" data-mp="13ntw31msk9im">
            {footerLinks.map(l => <li key={l.label} data-id="element-162" data-mp="yq22m36i0fcb">
                <a href={l.href} className="text-mute hover:text-sky focus:outline-none focus-visible:ring-2 focus-visible:ring-sky" data-id="element-163" data-mp="1ei2azd8ynzhu">
                  {l.label}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mt-4 text-xs text-mute" data-id="element-164" data-mp="1nbfcv4p06bg2">© Senvoria Digital 2026 — Todos los derechos reservados.</p>
        <p className="mt-1 text-xs text-mute/80" data-id="element-165" data-mp="1s85qlldc4uyb">
          Material educativo. No reemplaza a un técnico en reparaciones complejas o riesgosas.
        </p>
      </div>
    </footer>;
}